import React from 'react';

import * as S from './styled';

const STYLES = [
  "btn--primary--solid",
  "btn--danger--solid",
  "btn--success--solid",
  "btn--white--outline",
  "btn--dark--outline",
  "btn--primary--outline",
  "btn--danger--outline",
  "btn--success--outline",
  "btn--white--outline",
  "btn--dark--outline"
];

const SIZES = ["btn--medium", "btn--large"];

const Button = React.forwardRef(({
  children,
  text,
  type,
  onClick,
  buttonStyle,
  buttonSize
}, ref) => {

  

  const checkButtonStyle = STYLES.includes(buttonStyle)
    ? buttonStyle
    : STYLES[0];

  const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize :
  SIZES[0];

  return (
    <S.Button className={`${checkButtonStyle} ${checkButtonSize}`} onClick={onClick} type={type} ref={ref}>
      {children}
    </S.Button>
  );
}
);

export default Button
